import { FC, SVGAttributes } from 'react';

const Minus: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 13V11H17V13H7Z" fill="currentColor" />
        </svg>
    );
};

export default Minus;
